import { ThemeProvider } from "@/components/theme-provider";
import { LanguageProvider } from "@/hooks/useLanguage";
import { InstallPrompt } from "@/components/install-prompt";
import { Outlet, createRootRoute } from "@tanstack/react-router";

export const Route = createRootRoute({
  component: () => (
    <>
      <ThemeProvider attribute="class" defaultTheme="dark" enableSystem>
        <LanguageProvider>
          <Outlet />
          <InstallPrompt />
        </LanguageProvider>
      </ThemeProvider>
    </>
  ),
});
